import { useToggleState } from '@react-stately/toggle'
import { ToggleProps } from '@react-types/checkbox'
import { ExternalIntegration } from 'api/clients/ExternalIntegrationsClient'
import Styles from './AccountToggle.module.scss'
import ToggleButton from 'common/ToggleButton/ToggleButton'
import { AccountAvatar } from './AccountAvatar'
import { Text } from 'blaze-ui/Text/Text'

export const AccountToggle = ({
  account,
  ...props
}: {
  account: ExternalIntegration
} & ToggleProps) => {
  const state = useToggleState({ ...props })

  return (
    <div className={Styles.root}>
      <AccountAvatar account={account} />
      <div className={Styles.nameAndToggle}>
        <Text>{account.name}</Text>
        <ToggleButton
          name={account.id + account.provider}
          checked={state.isSelected}
          handleChange={(e) => state.setSelected(e.target.checked)}
          disabled={props.isDisabled}
        />
      </div>
    </div>
  )
}
